<template>
  <div class="enterprise-container animate__animated animate__fadeIn animate__faster" :class="customBoxClass" @click="goDetail">
    <img class="img" :src="item.cover" alt="">
    <div class="right">
      <div class="title text-ellipsis-1">{{item.relationName ||''}}</div>
      <div class="desc">{{item.enterpriseTypeName  ||''}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name:'common-enterprise-item',
  props: {
			type: {
				type: String,
				default: ""
			},
			item: {
				type: Object,
				default: ()=>({})
			},
			customBoxClass: {
				type: String,
				default: 'mt-11', // 空格分割的class列表，例如 "class1 class2"
			},
  },
  components:{},
  data() {
    return {}
  },
  methods: {
    goDetail() {
      console.log("11111",this.item.relationId)
      let enterpriseCode = this.item.relationId
      let language = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : ''
      if (enterpriseCode) {
        let query = {
          enterpriseCode,
          language
        }
        this.$router.push({
          path: `/mini-h5/index/enterpriseMainPage`,
          query,
        })
        // this.$router.push(`/mini-h5/index/enterpriseMainPage?enterpriseCode=${enterpriseCode}`)
      }
    },
  },
  mounted() {
    
  }
}
</script>
<style lang="less" scoped>
 .mt-11 {
   margin-top: 11px;
 }
 .mx-12 {
  margin-left: 12px;
  margin-right: 12px;
 }
.enterprise-container {
  display: flex;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  .img {
    width: 60px;
    height: 60px;
    background-color: #f5f5f5;
    border-radius: 10px;
    flex-shrink: 0;
    margin-right: 10px;
    object-fit: cover;
  }
  .right {
    .title {
      font-size: 15px;
      color: #262626;
      font-weight: 700;
    }
    .desc {
      margin-top: 5px;
      font-size: 12px;
      color: #8C8C8C;
    }
  }
}

</style>